export default "__VITE_ASSET__Dgp3hyCN__"